<template>
  <div class="reply-manager">
    <el-tabs v-model="editableTabsValue" @tab-click="handleTabClick" type="card">
      <el-tab-pane :key="item.name" v-for="item in replyList" :label="item.label" :name="item.name">
      </el-tab-pane>
    </el-tabs>
    <el-form label-width="130px" label-position="left" class="reply-manager-form" v-show="replyList.length > 0">
      <el-form-item label="话术内容：">
        <el-input v-model="currentItem.ans_text" placeholder="请输入话术内容" type="textarea"></el-input>
      </el-form-item>
      <upload-audio :audio.sync="currentItem.audio" :code="currentItem.ans_code"></upload-audio>
      <el-form-item v-for="(item, index) in currentItem.slot" :key="index" :label="`关联槽值${getIndex(currentItem.slot)}`">
        {{ getSlotName(item, index) }}
      </el-form-item>
      <el-form-item label="动作设置：">
        <el-radio-group v-model="currentItem.action">
          <el-radio :label="1">无</el-radio>
          <el-radio :label="2">挂机</el-radio>
          <el-radio :label="3">转人工</el-radio>
          <el-radio :label="4">重播</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否支持打断：">
        <el-switch v-model="currentItem.interrupt" :active-value="2" :inactive-value="1">
        </el-switch>
        <div class="interupt-container">
          <div class="el-form-item__label">是否作为默认话术：</div>
          <el-switch v-model="currentItem.is_default" :active-value="2" :inactive-value="1">
          </el-switch>
        </div>
      </el-form-item>

      <el-form-item label="相关链接：">
        <el-input v-model="currentItem.link_note" placeholder="此为链接说明" class="desc"></el-input>
        <el-input v-model="currentItem.link" placeholder="此为链接地址" class="address"></el-input>
      </el-form-item>
      <el-form-item label="展示标题：">
        <el-input v-model="currentItem.title" placeholder="请输入展示标题"></el-input>
      </el-form-item>
      <el-form-item label="展示图：">
        <upload-img :img.sync="currentItem.img" isDelete></upload-img>
      </el-form-item>
      <el-form-item label="富文本：">
        <editor v-model="currentItem.richtext" :options="{ height: 200 }" useImage></editor>
      </el-form-item>
      <el-form-item label="外部链接：">
        <el-input v-model="currentItem.jump_link" placeholder="请输入外部链接"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { isSuccess } from '@/utils/index'
import { deleteReply } from '@/api/aimManager'
export default {
  props: {
    status: Number,
  },
  data() {
    return {
      editableTabsValue: '0',
      isFirst: true,
      lastIndex: 0,
    }
  },
  components: {
    editor: () => import('@/components/editor/index.vue'),
    'upload-audio': () => import('@/components/uploadAudio/index.vue'),
    'upload-img': () => import('@/components/uploadImg/index.vue'),
  },

  computed: {
    ...mapState({
      currentItem: (state) => state.aimManager.currentItem,
      slotList: (state) => state.aimManager.slotList,
      replyList: (state) => state.aimManager.replyList,
      combineSlot: (state) => state.aimManager.combineSlot,
    }),
    getOptionValue() {
      return (val1, val2) => [val1, val2]
    },
    getSlotName() {
      return (items, index) => {
        let slot_name = ''
        let slot_val = ''
        this.slotList.forEach((vals) => {
          if (vals.id == index) {
            slot_name = vals.slot_name
            vals.chlid.forEach((val) => {
              if (val.id == items) {
                slot_val = val.slot_name
              }
            })
          }
        })
        if (slot_val) {
          return [slot_name, slot_val].join('/')
        }
        return slot_name
      }
    },
    getIndex() {
      let index = 1
      return (slot) => {
        if (index > Object.keys(slot).length) {
          index = 1
        }
        return index++
      }
    },
  },
  methods: {
    ...mapMutations('aimManager', [
      'deleteItem',
      'setCurrentItem',
      'addItem',
    ]),
    deleteInput(targetName) {
      this.$confirm('确认删除?').then(async (res) => {
        let activeName = this.editableTabsValue
        let currentIndex = -1
        let showIndex = -1
        this.replyList.forEach((tab, index) => {
          if (tab.name === targetName) {
            if (activeName == targetName) {
              let nextTab =
                this.replyList[index + 1] || this.replyList[index - 1]
              if (nextTab) {
                activeName = nextTab.name
                if (this.replyList[index + 1]) {
                  showIndex = index
                } else if (this.replyList[index - 1]) {
                  showIndex = index - 1
                }
              }
            }
            currentIndex = index
          }
        })
        this.editableTabsValue = activeName
        if (this.replyList[currentIndex].id) {
          const res = await deleteReply({
            id: this.replyList[currentIndex].id,
          })
          if (!isSuccess(res.code)) {
            return
          }
        }
        this.$message.success('删除成功')
        this.deleteItem({ currentIndex, showIndex })
      })
    },
    addForm() {
      if (this.isFirst) {
        this.lastIndex = this.replyList.length
        this.isFirst = false
      }
      let item = {
        action: 1,
        interrupt: 1,
        is_default: 1,
        ans_text: '',
        audio: '',
        link_note: '',
        link: '',
        title: '',
        richtext: '',
        img: '',
        jump_link: '',
        label: '回复话术' + (this.lastIndex + 1),
        name: String(this.lastIndex),
      }
      this.editableTabsValue = String(this.lastIndex)
      this.lastIndex++
      item.slotList = this.slotList
      this.addItem(item)
    },
    handleTabsEdit(targetName, action) {
      if (action === 'add') {
        this.addForm()
      }
      if (action === 'remove') {
        this.deleteInput(targetName)
      }
    },
    handleTabClick({ index }) {
      this.setCurrentItem(parseInt(index))
    },
  },
}
</script>

<style lang="scss">
.reply-manager {
  height: 500px;
  overflow-y: scroll;

  .add-form {
    width: 100%;
    //   max-width: 600px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .reply-manager-form {
    margin: 10px 0 0 30px;
    position: relative;

    //   width: 100%;
    .delete {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: flex-end;

      .el-icon-circle-close:before {
        width: 50px;
        height: 50px;
        margin-left: 10px;
        font-size: 40px;
        color: red;
        z-index: 999;
        cursor: pointer;
      }
    }

    .el-input {
      width: 80%;
    }
  }

  .el-tabs__item {
    padding: 0 24px;
  }

  .el-form-item__content {
    display: flex;
    align-items: center;
  }

  .interupt-container {
    margin-left: 141px;
  }

  .el-radio-group {
    line-height: 40px;
  }
}

.reply-manager::-webkit-scrollbar {
  width: 0;
}

.reply-manager-form {
  .desc {
    width: 24% !important;
    margin-right: 10px;
  }

  .address {
    width: 70% !important;
  }

  .el-input {
    width: 80%;
  }

  .el-switch__core {
    width: 55px;
    height: 27px;
    border-radius: 13px;
  }

  .el-switch__core:after {
    top: 5px;
  }

  .el-cascader {
    width: 100%;
  }

  .w-e-text {
    width: 80%;
  }
}

.reply-container {
  display: flex;

  .reply-lf {
    flex-shrink: 0;
    width: 90px;
    font-size: 16px;
    font-weight: 700;
  }

  .el-form-item__content {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 10px;
    }
  }
}
</style>
